import { useEffect, useState } from 'react';
import { DEFAULT_PUBLIC_CONFIG, PublicConfig, fetchPublicConfig } from '../services/systemApi';

/** Admin-controlled platform config (feature switches, announcement, signup credits). Defaults until loaded. */
export function useSystemConfig(): PublicConfig {
  const [config, setConfig] = useState<PublicConfig>(DEFAULT_PUBLIC_CONFIG);
  useEffect(() => {
    let alive = true;
    fetchPublicConfig().then((c) => alive && setConfig(c));
    return () => {
      alive = false;
    };
  }, []);
  return config;
}
